import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, X } from 'lucide-react'

import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    indicator?: 'check' | 'x'
  }
>(({ className, indicator = 'check', ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      `data-[state=unchecked]:group-hover:bg-text-primary/5 grid place-content-center peer size-6 shrink-0 rounded-[4px] bg-field-2 border border-strong-01 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-funkia data-[state=checked]:text-white data-[state=checked]:border-0`,
      {
        'data-[state=checked]:bg-error-solid data-[state=checked]:text-error-solid-fg data-[state=checked]:border-error':
          indicator === 'x',
      },
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('grid place-content-center text-current')}>
      {indicator === 'x' ? <X className="size-4" /> : <Check className="size-4" />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
